import { Link } from "react-router-dom";
import { Star, CircleCheckBig } from "lucide-react";
import Avatar from "../common/Avatar";
import RankBadge from "../social/RankBadge";
import RankProgressBar from "./RankProgressBar";

export default function LeaderboardRow({ entry, currentUserId, animationDelay }) {
  const isCurrentUser = entry.user.id === currentUserId;

  return (
    <Link
      to={`/users/${entry.user.id}`}
      className={`flex items-center gap-4 p-4 bg-cream rounded-lg shadow-card hover:shadow-card-hover transition-shadow ${
        isCurrentUser ? "ring-2 ring-terracotta/40 bg-terracotta/5" : ""
      }`}
      style={{
        animation: "leaderboard-enter 0.4s ease-out forwards",
        animationDelay: `${animationDelay}ms`,
        opacity: 0,
      }}
    >
      <span className="w-8 text-center font-display font-bold text-walnut-light text-lg">
        {entry.position}
      </span>
      <Avatar user={entry.user} size="sm" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium text-walnut truncate">{entry.user.display_name}</span>
          {entry.user.is_verified && <CircleCheckBig size={14} className="text-terracotta flex-shrink-0" />}
          <RankBadge rank={entry.user.rank} />
          {isCurrentUser && (
            <span className="text-[10px] font-semibold text-terracotta uppercase tracking-wider flex-shrink-0">
              You
            </span>
          )}
        </div>
        <div className="flex items-center gap-3 mt-0.5 text-xs text-walnut-light">
          <span className="font-semibold text-amber">{entry.user.community_points} CP</span>
          {entry.user.rating_avg != null && (
            <span className="inline-flex items-center gap-0.5">
              <Star size={11} className="fill-amber text-amber" />
              {entry.user.rating_avg.toFixed(1)}
              ({entry.user.rating_count})
            </span>
          )}
        </div>
        <RankProgressBar points={entry.user.community_points} />
      </div>
    </Link>
  );
}
